(function($){

    var dateLogic = false;

    $('.price-form-wrapper .input-field').on('change',function(){
        $(this).addClass('changed');
        var lang = $('#price-form-submit').attr('data-lang');
        var urlbase = $('#price-form-submit').attr('data-urlbase');
        var valStart = $('.price-form-wrapper .start').val();
        var valEnd = $('.price-form-wrapper .end').val();

        if(new Date(valStart) < new Date(valEnd)){
            dateLogic = true;
        } else {
            dateLogic = false;
        }

        var startDate    = new Date(valStart),
            yr      = startDate.getFullYear(),
            month   = startDate.getMonth() < 10 ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1),
            day     = startDate.getDate()  < 10 ? '0' + startDate.getDate()  : startDate.getDate(),
            newDateStart = day + '/' + month + '/' + yr;

        var startEnd    = new Date(valEnd),
            yr      = startEnd.getFullYear(),
            month   = startEnd.getMonth() < 10 ? '0' + (startEnd.getMonth() + 1) : (startEnd.getMonth() + 1),
            day     = startEnd.getDate()  < 10 ? '0' + startEnd.getDate()  : startEnd.getDate(),
            newDateEnd = day + '/' + month + '/' + yr;

        var newUrl = urlbase + 'lang=' + lang + '&from=' + newDateStart + '&to=' + newDateEnd;

        $('#price-form-submit').attr('href',newUrl);

        if($('.price-form-wrapper .start').hasClass('changed') && $('.price-form-wrapper .end').hasClass('changed') && dateLogic == true){
            $('#price-form-submit').removeClass('disable');
        } else {
            $('#price-form-submit').addClass('disable');
        }

    });

})
(jQuery);
